import React from 'react'
import './request-action/sections/forms/PaymentInstructions.css' // Importing CSS file for styling
interface BankDetailsFormProps {
  bsb: string
  accountNumber: string
  billerCode: string
}

const BankDetailsForm: React.FC<BankDetailsFormProps> = ({ bsb, accountNumber, billerCode }) => {
  return (
    <div className="payment-instructions-container" style={{ marginLeft: '40px' }}>
      <h2 className="payment-instructions-title">Payment Instructions</h2>
      <p>
        You will need to deposit the Cash Security Amount before your bank guarantee can be issued.
      </p>
      <p>
        Please pay the full amount to the bank account below, using the last four characters of your
        proposed Guarantee ID as the reference on the transfer.
      </p>
      <div className="payment-details">
        <p>Perpetual Corporate Trust Limited ACF iDeed Pty Ltd & MyGX Pty Ltd</p>
        <p>Westpac Bank</p>
        <p>BSB: 032 016</p>
        <p>ACC: 703 700</p>
      </div>
    </div>
  )
}

export default BankDetailsForm
